import DOMPurify from 'isomorphic-dompurify';

export function purifyHtml(html) {
	return DOMPurify.sanitize(html);
}
